import React from 'react';
import { Target, Users, Award, TrendingUp } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-gradient-to-b from-gray-900 to-gray-800">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Text Content */}
            <div itemScope itemType="https://schema.org/Organization">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" itemProp="name">
                Qui Sommes-Nous ?
              </h2>
              <div className="space-y-4 text-gray-300 text-lg leading-relaxed" itemProp="description">
                <p>
                  Galo Bet est né d'une simple conviction : chaque parieur mérite d'avoir accès aux meilleures opportunités sans perdre de temps à comparer des dizaines de sites.
                </p>
                <p>
                  Notre mission est de démystifier le monde des paris en ligne français en vous fournissant des analyses approfondies, des comparaisons objectives et des recommandations transparentes basées sur des critères concrets : bonus réels, rapidité des retraits, qualité du service client, et expérience utilisateur.
                </p>
                <p>
                  Nous testons chaque site, négocions les meilleures offres, et vous accompagnons dans votre parcours de parieur pour que chaque mise compte vraiment.
                </p>
              </div>
            </div>

            {/* Stats Cards */}
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-gradient-to-br from-pink-600/20 to-pink-800/20 backdrop-blur-sm rounded-xl p-6 border border-pink-500/30">
                <div className="w-12 h-12 bg-pink-600 rounded-lg flex items-center justify-center mb-4">
                  <Target className="text-white" size={24} />
                </div>
                <div className="text-3xl font-bold text-white mb-2">50+</div>
                <div className="text-gray-400 text-sm">Sites Analysés</div>
              </div>

              <div className="bg-gradient-to-br from-pink-600/20 to-pink-800/20 backdrop-blur-sm rounded-xl p-6 border border-pink-500/30">
                <div className="w-12 h-12 bg-pink-600 rounded-lg flex items-center justify-center mb-4">
                  <Users className="text-white" size={24} />
                </div>
                <div className="text-3xl font-bold text-white mb-2">10K+</div>
                <div className="text-gray-400 text-sm">Parieurs Avisés</div>
              </div>

              <div className="bg-gradient-to-br from-pink-600/20 to-pink-800/20 backdrop-blur-sm rounded-xl p-6 border border-pink-500/30">
                <div className="w-12 h-12 bg-pink-600 rounded-lg flex items-center justify-center mb-4">
                  <Award className="text-white" size={24} />
                </div>
                <div className="text-3xl font-bold text-white mb-2">100%</div>
                <div className="text-gray-400 text-sm">Indépendant</div>
              </div>

              <div className="bg-gradient-to-br from-pink-600/20 to-pink-800/20 backdrop-blur-sm rounded-xl p-6 border border-pink-500/30">
                <div className="w-12 h-12 bg-pink-600 rounded-lg flex items-center justify-center mb-4">
                  <TrendingUp className="text-white" size={24} />
                </div>
                <div className="text-3xl font-bold text-white mb-2">24/7</div>
                <div className="text-gray-400 text-sm">Mises à Jour</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

